import DadosPage from './dados.page'

export default DadosPage
